import $ from 'jquery';
import manager from 'app/module46/component-manager.js';

manager.register('profile', (component, elements, attributes, properties) => {

	const $component = $(component);

	const {
		edit
	} = attributes;
	
	const $profile = $(elements.profile);
	const $editProfileButton = $(elements.editProfileButton);
	const $cancelProfileButton = $(elements.cancelProfileButton);
	const $chancePictureButton = $(elements.chancePictureButton);
	const $changePasswordButton = $(elements.changePasswordButton);
	const $cancelPasswordButton = $(elements.cancelPasswordButton);
	const $changePassword = $(elements.changePassword);
	const $logoutButton = $(elements.logoutButton);
	const $cancelButton = $(elements.cancelButton);

	const $refresh = $component.find('form, ul');
	const $readForm = $profile.find('.form--read');
	const $editForm = $profile.find('.form--edit');

	function editProfile() {
		$editProfileButton.hide();
		$refresh.hide();
		$readForm.hide();
		$logoutButton.hide();
		$changePassword.hide();
		$cancelButton.show();
		$chancePictureButton.show();
		$changePasswordButton.show();
		$editForm.show();
		$profile.show();
		$refresh.hide().fadeIn();
	}

	function cancelProfile(ev) {
		$editProfileButton.show();
		$editForm.hide();
		$chancePictureButton.hide();
		$changePasswordButton.hide();
		$changePassword.hide();
		$cancelButton.hide();
		$logoutButton.show();
		$readForm.show();
		$profile.hide().fadeIn();
		manager.undo(elements.profile);
		$component[0].scrollIntoView({
			behavior: 'smooth'
		});
		$refresh.hide().fadeIn();
	}		

	function changePassword()
	{
		$profile.hide();
		$changePasswordButton.hide();
		$chancePictureButton.hide();
		$editProfileButton.show();
		$changePassword.fadeIn();
		$refresh.hide().fadeIn();
	}

	$editProfileButton.click((ev) => {
		ev.preventDefault();
		editProfile();
	});

	$changePasswordButton.click((ev) => {
		ev.preventDefault();
		changePassword();
	});

	$cancelButton.click((ev) => {
		ev.preventDefault();
		cancelProfile();
	});
	$cancelProfileButton.click((ev) => {
		ev.preventDefault();
		cancelProfile();
	});
	$cancelPasswordButton.click((ev) => {
		ev.preventDefault();
		cancelProfile();
	});

	switch(edit) {
		case 'profile': editProfile(); break;
		case 'password': changePassword(); break;
	}
});
